import { ContentGroup, ErrorSummary, Grid, GridItem, Heading, List, ListItem, Text, } from '@imported/constellation';
import React from 'react';
import { useLabelContext } from '../../context/LabelContext.js';
import { VerticalSpace } from '../FormFields/index.js';
import { CommonFormStyleWrapper } from '../FormFields/styles.js';
import Navigation from '../Navigation/index.js';
const RetakeScreenForm = ({ handleRetakeScreenSubmission, }) => {
    const { getLabelFromContext } = useLabelContext();
    const points = getLabelFromContext('components.retakeScreen.points');
    return (React.createElement(CommonFormStyleWrapper, null,
        React.createElement(Grid, null,
            React.createElement(GridItem, null,
                React.createElement(ContentGroup, null,
                    React.createElement(ErrorSummary, { title: '' },
                        React.createElement(Heading, { size: 's4' }, getLabelFromContext('components.retakeScreen.heading')),
                        React.createElement(Text, null, getLabelFromContext('components.retakeScreen.message')),
                        React.createElement(VerticalSpace, { space: 20 }),
                        React.createElement(Text, null, getLabelFromContext('components.retakeScreen.note')),
                        React.createElement(VerticalSpace, { space: 24 }),
                        React.createElement(List, null, points.map((item) => (React.createElement(ListItem, { key: item }, item))))),
                    React.createElement(Navigation, { submitLabel: getLabelFromContext('components.allowPermissionForm.navigation.next'), handleNext: handleRetakeScreenSubmission }))))));
};
export default RetakeScreenForm;
//# sourceMappingURL=index.js.map